import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { postWithAuth, getWithAuth, putWithAuth } from '../../../api/api';
import { API_URLS } from '../../../api/apiConfig';

const ModalChangeUserProperties = ({ onClose, user }) => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [allProperties, setAllProperties] = useState([]);
    const [userProperties, setUserProperties] = useState(
        user.properties_list?.map((property) => property.property_id) || []
    );

    // Fetch all available properties
    const getProperties = async () => {
        try {
            setIsLoading(true);
            const response = await getWithAuth(API_URLS.GET_PROPERTIES);
            if (response.message === 'success') {
                setAllProperties(response.data);
                console.log('All Properties:', response.data);
            } else {
                setAlertMessage(response.detail || "Error fetching properties");
                setShowAlert(true);
            }
        } catch (error) {
            console.error('Error fetching properties:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getProperties();
    }, []);

    // Handle checkbox toggle
    const handleCheckboxChange = (property) => {
        setUserProperties((prevProperties) => {
            const exists = prevProperties.includes(property.id);
            if (exists) {
                // Remove the property ID if it already exists
                return prevProperties.filter((id) => id !== property.id);
            } else {
                // Add the property ID if it does not exist
                return [...prevProperties, property.id];
            }
        });
    };

    // Save updated properties
    const savePropertiesList = async () => {
        const updatedUserProperties = {
            properties_list_id: userProperties,
        };

        try {
            setIsLoading(true);
            const response = await putWithAuth(
                API_URLS.ADD_PROPERTIES(user.id),
                updatedUserProperties
            );
            if (response.message === 'success') {
                window.location.reload();
            } else {
                setAlertMessage(response.detail || "Error saving properties");
                setShowAlert(true);
            }
        } catch (error) {
            console.error('Error saving properties:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={true} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Añadir propiedades a usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '10vh' }}>
                                <div className="spinner-grow text-color-verde-wofyrooms" style={{ width: "5rem", height: "5em" }} role="status">
                                </div>
                            </div>
                        ) : (
                            <>
                {showAlert && (
                    <div className="alert alert-danger">
                        {alertMessage}
                    </div>
                )}
                <div>
                    <h5>Propiedades disponibles:</h5>
                    <div>
                        {allProperties.map((property) => {
                            const isChecked = userProperties.includes(property.id);
                            return (
                                <div key={property.id} className="form-check m-3">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`property-${property.id}`}
                                        checked={isChecked}
                                        onChange={() => handleCheckboxChange(property)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`property-${property.id}`}
                                    >
                                        <span>{property.name}</span>
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>
                </>
                        )}
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={savePropertiesList}
                    disabled={isLoading}
                >
                    {isLoading ? "Guardando..." : "Guardar cambios"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalChangeUserProperties;
